import React from 'react'
import bg from '../../../public/static/image-background/logo-v-02.png'
import config from '../../../constants/config'
import { getBase64, formatDateTime, useTranslation } from '../../../constants/helpers'

const PlayersList14 = ({ id, players, league, size, setIsReady, isShowBirthDay, seasonData, teamData, checkboxPlayer, checkboxStaff, sponsorData, isShowSponsor }) => {
    const { t } = useTranslation()
    const width = size
    const px = width / 100
    const sizeItemLogo = px * 12
    const [listUser, setListUser] = React.useState([])

    const color = {
        crimson: '#dc2626',
        crimsonLight: '#ef4444',
        crimsonDark: '#991b1b',
        gold: '#fbbf24',
        goldLight: '#fde68a',
        bg: '#1a0005',
        rowBg1: 'rgba(220,38,38,0.06)',
        rowBg2: 'rgba(220,38,38,0.13)',
        border: 'rgba(220,38,38,0.3)',
        text: '#ffffff',
        subText: 'rgba(253,164,175,0.85)'  // light pink
    }

    // Compact font – no wrapping
    const nameFontSize = (name, base) => {
        if (!name) return `${base}px`
        if (name.length > 22) return `${base * 0.65}px`
        if (name.length > 16) return `${base * 0.8}px`
        return `${base}px`
    }

    const listPlayer = players?.reduce(
        (p, c) => {
            if (!p[c.types]) p[c.types] = []
            if (c.types?.length > 1) {
                p['football_player_type'].push(c)
                p['football_staff_type'].push(c)
                return p
            }
            p[c.types].push(c)
            return p
        },
        { football_player_type: [], football_staff_type: [] }
    )

    const arrPriority = ['football_team_manager', 'football_coach', 'football_coach_assistant', 'football_medical_staff', 'football_marketing', 'football_other_staff']
    const maxSortIndex = arrPriority?.length
    const _staffs = listPlayer?.football_staff_type
        ?.map(item => {
            const positions = item?.positions
                ?.map(i => {
                    const sortIndex = arrPriority.findIndex(p => p == i)
                    return { value: i, sortIndex: sortIndex == -1 ? maxSortIndex : sortIndex }
                })
                .sort((a, b) => a.sortIndex - b.sortIndex)
                ?.map(p => p.value)
            const sortIndex = arrPriority?.findIndex(p => p == positions[0])
            return { ...item, positions, sortIndex: sortIndex == -1 ? maxSortIndex : sortIndex }
        })
        .sort((a, b) => a.sortIndex - b.sortIndex)

    const footballPlayers = listPlayer?.football_player_type || []

    const onLoaded = value => {
        setListUser(s => [...s, value])
    }

    React.useEffect(() => {
        if (listUser?.length === listPlayer?.football_staff_type?.length + listPlayer.football_player_type?.length) {
            setIsReady?.(true)
        }
    }, [listUser])

    const staffPosition = {
        football_coach: t('football_coach'),
        football_coach_assistant: t('football_coach_assistant'),
        football_marketing: t('football_marketing'),
        football_medical_staff: t('football_medical_staff'),
        football_other_staff: t('football_other_staff'),
        football_team_manager: t('football_team_manager')
    }

    // Staff: 2 columns
    const staffMid = Math.ceil((_staffs?.length || 0) / 2)
    const leftStaffs = _staffs?.slice(0, staffMid) || []
    const rightStaffs = _staffs?.slice(staffMid) || []

    // Players: 2 columns
    const playerMid = Math.ceil(footballPlayers.length / 2)
    const leftPlayers = footballPlayers.slice(0, playerMid)
    const rightPlayers = footballPlayers.slice(playerMid)

    const rowH = px * 5.5
    const avatarRow = px * 4.2
    const colPosW = px * 22

    // Shared row renderer
    const renderStaffRow = (i, idx, isLast, keyName) => (
        <div key={keyName} style={{
            display: 'flex', flexDirection: 'row', alignItems: 'center',
            height: `${rowH}px`,
            backgroundColor: idx % 2 === 0 ? color.rowBg1 : color.rowBg2,
            borderBottom: !isLast ? `1px solid ${color.border}` : 'none',
            padding: `0 ${px}px`
        }}>
            <div style={{ marginRight: `${px}px`, flexShrink: 0 }}>
                <Image onLoad={onLoaded} src={i.avatar || config.logo} style={{
                    width: `${avatarRow}px`, height: `${avatarRow}px`,
                    border: `${px * 0.2}px solid ${color.crimson}`,
                    borderRadius: '50%', objectFit: 'cover',
                    boxShadow: `0 0 6px rgba(220,38,38,0.35)`
                }} />
            </div>
            <div style={{ width: colPosW, flexShrink: 0 }}>
                <p style={{ color: color.crimsonLight, fontSize: `${px * 1.35}px`, textTransform: 'uppercase', margin: 0, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', fontStyle: 'italic' }}>{staffPosition[i.positions[0]] || i?.positions[0]}</p>
            </div>
            <div style={{ flex: 1, minWidth: 0 }}>
                <p style={{ color: color.text, fontSize: nameFontSize(i.name, px * 1.75), textTransform: 'uppercase', fontWeight: 'bold', margin: 0, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{i.name}</p>
                {isShowBirthDay && <p style={{ color: color.subText, fontSize: `${px * 1.2}px`, margin: 0, whiteSpace: 'nowrap' }}>{formatDateTime(i.birthday, 'date')}</p>}
            </div>
        </div>
    )

    const renderPlayerRow = (i, idx, isLast, keyName) => (
        <div key={keyName} style={{
            display: 'flex', flexDirection: 'row', alignItems: 'center',
            height: `${rowH}px`,
            backgroundColor: idx % 2 === 0 ? color.rowBg1 : color.rowBg2,
            borderBottom: !isLast ? `1px solid ${color.border}` : 'none',
            padding: `0 ${px}px`
        }}>
            <div style={{ width: `${px * 3.5}px`, flexShrink: 0, textAlign: 'center' }}>
                <span style={{ color: color.gold, fontSize: `${px * 1.8}px`, fontWeight: 'bold', fontFamily: 'SFUHelveticaCondensedBold' }}>{i.shirtNumber ?? ''}</span>
            </div>
            <div style={{ marginRight: `${px}px`, flexShrink: 0 }}>
                <Image onLoad={onLoaded} src={i.avatar || config.logo} style={{
                    width: `${avatarRow}px`, height: `${avatarRow}px`,
                    border: `${px * 0.2}px solid ${color.crimson}`,
                    borderRadius: '50%', objectFit: 'cover'
                }} />
            </div>
            <div style={{ flex: 1, minWidth: 0 }}>
                <p style={{ color: color.text, fontSize: nameFontSize(i.name, px * 1.75), textTransform: 'uppercase', fontWeight: 'bold', margin: 0, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{i.name}</p>
                {isShowBirthDay && <p style={{ color: color.subText, fontSize: `${px * 1.2}px`, margin: 0, whiteSpace: 'nowrap' }}>{formatDateTime(i.birthday, 'date')}</p>}
            </div>
        </div>
    )

    return (
        <div id={id} style={{ backgroundColor: color.bg, width: width, paddingBottom: isShowSponsor && sponsorData?.length > 0 ? px * 10 : px * 3, position: 'relative', overflow: 'hidden', fontFamily: 'SFUHelveticaCondensedBold' }}>
            {/* Radial vignette */}
            <div style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', zIndex: 0, backgroundImage: `radial-gradient(circle, rgba(220,38,38,0.07) 1px, transparent 1px)`, backgroundSize: `${px * 4}px ${px * 4}px` }} />
            <div style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: `${px * 25}px`, background: `linear-gradient(to bottom, rgba(153,27,27,0.25) 0%, transparent 100%)`, zIndex: 0 }} />

            <div style={{ position: 'relative', zIndex: 1 }}>

                {/* ========== HEADER BANNER ========== */}
                <div style={{ background: `linear-gradient(135deg, #1a0005 0%, #7f1d1d 50%, #1a0005 100%)`, borderBottom: `${px * 0.3}px solid ${color.gold}`, padding: `${px * 2}px ${px * 2.5}px` }}>
                    <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center' }}>
                        {/* Left: team */}
                        <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', flex: 1 }}>
                            <Image src={teamData?.logo} style={{ width: `${sizeItemLogo}px`, height: `${sizeItemLogo}px`, objectFit: 'contain', filter: `drop-shadow(0 0 ${px * 0.6}px rgba(220,38,38,0.7))` }} />
                            <div style={{ marginLeft: `${px}px` }}>
                                <p style={{ color: '#fca5a5', fontSize: `${px * 1.4}px`, textTransform: 'uppercase', margin: 0, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', maxWidth: `${px * 20}px` }}>{league?.name}</p>
                                <p style={{ color: color.text, fontSize: `${px * 1.8}px`, textTransform: 'uppercase', margin: 0, fontWeight: 'bold', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', maxWidth: `${px * 20}px` }}>{teamData?.name}</p>
                            </div>
                        </div>

                        {/* Center: title */}
                        <div style={{ flex: 2, display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                            <h1 style={{ color: color.gold, fontSize: `${px * 3.5}px`, textTransform: 'uppercase', textAlign: 'center', margin: 0, fontWeight: 'bold', textShadow: `0 0 10px rgba(251,191,36,0.5)`, letterSpacing: `${px * 0.05}px`, lineHeight: 1.1 }}>{t('list_team_member')}</h1>
                            <p style={{ color: '#fca5a5', fontSize: `${px * 1.8}px`, textTransform: 'uppercase', textAlign: 'center', margin: `${px * 0.3}px 0 0` }}>{seasonData?.name}</p>
                        </div>

                        {/* Right */}
                        <div style={{ flex: 1, display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'flex-end' }}>
                            <div style={{ marginRight: `${px}px` }}>
                                <Image src={bg} style={{ width: `${sizeItemLogo * 0.7}px`, objectFit: 'contain' }} />
                            </div>
                            <Image src={seasonData?.logo} style={{ width: `${sizeItemLogo}px`, height: `${sizeItemLogo}px`, objectFit: 'contain', filter: `drop-shadow(0 0 ${px * 0.6}px rgba(220,38,38,0.6))` }} />
                        </div>
                    </div>
                </div>

                <div style={{ padding: `${px * 2}px ${px * 2.5}px 0` }}>

                    {/* ========== STAFF – 2-COLUMN ROWS ========== */}
                    {_staffs?.length > 0 && checkboxStaff && (
                        <div style={{ marginBottom: `${px * 2}px` }}>
                            <div style={{ display: 'flex', alignItems: 'center', marginBottom: `${px}px` }}>
                                <div style={{ width: `${px * 0.5}px`, height: `${px * 2.8}px`, background: color.crimson, marginRight: `${px * 0.8}px`, boxShadow: `0 0 6px rgba(220,38,38,0.6)` }} />
                                <h2 style={{ color: color.gold, fontSize: `${px * 2}px`, textTransform: 'uppercase', margin: 0 }}>{t('staff')}</h2>
                            </div>

                            {/* 2-column staff table */}
                            <div style={{ display: 'flex', flexDirection: 'row', gap: `${px * 1.5}px` }}>
                                <div style={{ flex: 1, border: `1px solid ${color.border}`, borderRadius: `${px * 0.8}px`, overflow: 'hidden' }}>
                                    {leftStaffs.map((i, idx) => (
                                        renderStaffRow(i, idx, idx === leftStaffs.length - 1, `sl-${idx}`)
                                    ))}
                                </div>
                                {rightStaffs.length > 0 && (
                                    <div style={{ flex: 1, border: `1px solid ${color.border}`, borderRadius: `${px * 0.8}px`, overflow: 'hidden' }}>
                                        {rightStaffs.map((i, idx) => (
                                            renderStaffRow(i, idx, idx === rightStaffs.length - 1, `sr-${idx}`)
                                        ))}
                                    </div>
                                )}
                            </div>
                        </div>
                    )}

                    {/* Gold divider */}
                    {_staffs?.length > 0 && checkboxStaff && footballPlayers?.length > 0 && checkboxPlayer && (
                        <div style={{ width: '100%', height: `${px * 0.2}px`, background: `linear-gradient(90deg, transparent, ${color.gold}, transparent)`, marginBottom: `${px * 1.5}px` }} />
                    )}

                    {/* ========== PLAYERS – 2-COLUMN TABLE ========== */}
                    {footballPlayers?.length > 0 && checkboxPlayer && (
                        <div>
                            <div style={{ display: 'flex', alignItems: 'center', marginBottom: `${px}px` }}>
                                <div style={{ width: `${px * 0.5}px`, height: `${px * 2.8}px`, background: color.crimson, marginRight: `${px * 0.8}px`, boxShadow: `0 0 6px rgba(220,38,38,0.6)` }} />
                                <h2 style={{ color: color.crimsonLight, fontSize: `${px * 2}px`, textTransform: 'uppercase', margin: 0, textShadow: `0 0 8px rgba(220,38,38,0.4)` }}>{t('player')}</h2>
                            </div>

                            <div style={{ display: 'flex', flexDirection: 'row', gap: `${px * 1.5}px` }}>
                                <div style={{ flex: 1, border: `1px solid ${color.border}`, borderRadius: `${px * 0.8}px`, overflow: 'hidden' }}>
                                    {leftPlayers.map((i, idx) => (
                                        renderPlayerRow(i, idx, idx === leftPlayers.length - 1, `pl-${idx}`)
                                    ))}
                                </div>
                                <div style={{ flex: 1, border: `1px solid ${color.border}`, borderRadius: `${px * 0.8}px`, overflow: 'hidden' }}>
                                    {rightPlayers.map((i, idx) => (
                                        renderPlayerRow(i, idx, idx === rightPlayers.length - 1, `pr-${idx}`)
                                    ))}
                                </div>
                            </div>
                        </div>
                    )}
                </div>
            </div>

            {/* ========== SPONSOR BAR ========== */}
            {isShowSponsor && sponsorData?.length > 0 && (
                <div style={{ height: `${8 * px}px`, width: '100%', position: 'absolute', bottom: `${px * 0.5}px`, padding: `${0.8 * px}px 0`, background: `linear-gradient(90deg, rgba(153,27,27,0.3), rgba(220,38,38,0.2), rgba(153,27,27,0.3))`, border: `${px * 0.1}px solid rgba(220,38,38,0.3)`, zIndex: 2 }}>
                    <div style={{ width: '95%', height: '100%', backgroundColor: 'rgba(26,0,5,0.9)', margin: '0 auto', borderRadius: `${3 * px}px`, display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'center', border: `${px * 0.1}px solid rgba(220,38,38,0.2)` }}>
                        {sponsorData?.slice(0, 10)?.map((i, idx) => (
                            <Image key={idx} src={i.logo || config.logo} style={{ width: 'auto', maxHeight: `${px * 5}px`, backgroundColor: 'white', objectFit: 'cover', marginRight: `${2 * px}px`, borderRadius: `${px * 0.5}px` }} />
                        ))}
                    </div>
                </div>
            )}

            {/* Footer */}
            <p style={{ position: 'relative', zIndex: 1, textAlign: 'right', color: 'rgba(252,165,165,0.35)', fontSize: `${px * 1.5}px`, margin: `${px}px ${px * 2.5}px 0`, fontWeight: 'bold' }}>
                {window.sessionStorage.getItem('HomeUrl') || 'VSPORT EXCLUSIVE'}
            </p>
        </div>
    )
}

const Image = props => {
    const [data, setData] = React.useState(null)
    React.useEffect(() => {
        if (props?.src?.includes('ui-avatars')) {
            getBase64(config.logo).then(r => setData(r))
        } else {
            getBase64(props.src).then(r => setData(r))
        }
    }, [props.src])
    return data ? <img {...props} src={data} onLoad={props.onLoad} alt="" /> : null
}

const areEqual = (p, n) => {
    return (
        JSON.stringify(p.players) === JSON.stringify(n.players) &&
        JSON.stringify(p.checkboxPlayer) === JSON.stringify(n.checkboxPlayer) &&
        JSON.stringify(p.checkboxStaff) === JSON.stringify(n.checkboxStaff) &&
        JSON.stringify(p.isShowBirthDay) === JSON.stringify(n.isShowBirthDay) &&
        JSON.stringify(p.isShowSponsor) === JSON.stringify(n.isShowSponsor) &&
        JSON.stringify(p.sponsorData) === JSON.stringify(n.sponsorData)
    )
}

export default React.memo(PlayersList14, areEqual)
